module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#tc5",
      "id": "ch5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p35-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Beulah and me went on together happy from there, all the way to the bottom of Master Jefferson’s Little Mountain, and so I decided to keep right on into town and wait there. Wouldn’t James be surprised, I thought with satisfaction. But we no sooner hit the public road, when here came a white man, in a long travellin’ coat, atop a big bay gelding, with a box tied on behind his saddle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hold there, nigger,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Oh, I held, believe me, as the man rode his horse up close. Beulah, though a good two hands shorter, was not spooked, and showed her teeth, and the man’s horse backed up a step.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You got your pass this morning, nigger?” said the man.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I dropped my eyes. “Sorry, Marse. I got no pass, this mornin’. Forgot it, silly me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Forgot it? Don’t you know it’s a crime not to have your pass, nigger? Why, I could have you arrested. Who do you belong to?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mr. Thomas Jefferson, he my Master. He sent me to scout the road ahead,” I said, which wasn’t bendin’ the truth too awful much. I gave him a foolish grin. “We on our way to Philadelphia.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v(" “Oh!” he said, pushin’ his hat back. “Why didn’t you say so, nigger? Save me all this bother arguing with you. I shall be traveling with Mr. Jefferson and his party. Goin’ up the mountain just now to meet him for breakfast. Now I’m late, thanks to you.”")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sorry, Marse.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Address me as Mr. Rattiff.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, Marse.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Did you not hear? Address me as Mr. Rattiff.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mr. Rattiff.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Rat"), _c('i', [_vm._v("tiff")]), _vm._v(". Mr. Rat"), _c('i', [_vm._v("tiff")]), _vm._v(", in the French manner.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mr. Rat"), _c('i', [_vm._v("tiff")]), _vm._v(" in the French manner,” I said, all in one go. That got his goat, as intended.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, no, goddamn it. "), _c('i', [_vm._v("Just")]), _vm._v(" Mr. Rat"), _c('i', [_vm._v("tiff")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mr. Rat"), _c('i', [_vm._v("tiff")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Finally!” he said, slapping his pant leg. “God, I hate to deal with dumb niggers. Breakfast is probably cold by now, with all this frittering around.” He broke his horse into a trot and turned up the mountain road. “Don’t you be going on farther without your pass,” he called back. “You ought to know that much at "), _c('i', [_vm._v("least")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just as the man got out of sight, Beulah lifted up her bushy tail and peed. Then shat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Thank you,” I said, pattin’ her neck. “My sentiments exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But it was true what he said about havin’ no pass, so I got down off Beulah, tied the reins to a branch, and set myself on a tree log close beside. I would just have to wait ‘till Mr. Jefferson showed. He and James and Mr. Rat"), _c('i', [_vm._v("tiff")]), _vm._v(". Beulah pushed her nose around in the leaves to forage.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("I watched her. “"), _c('i', [_vm._v("You")]), _vm._v(" may be happy to just stand around ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("and eat,” I said, “but it galls me to set here idle. For I am full of adventure for the road!”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Beulah lifted her head, and took a good look at me, but kept her big teeth grindin’ away, grass stems hangin’ from her lips. When she had done, she dropped her head and pushed around in the leaves with her nose for more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Any chance you get, you eat,” I said, disgusted. “You know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But watchin’ her made me hungry, so I got from my sack another of Mama’s corn cakes, and nibbled away at it, little by little, so it would last. The cake was still just a tad warm and smelled of her hearth, which sent a pang of homesickness through me. And here I was barely started. So I began to consider the long road ahead in a more resolute manner. Except tiredness crept over me, for I had lain awake a long while the night before, thinking of this very morning. Now that I was in it, I could hardly keep my eyes open. Figurin’ that Mr. Jefferson would not be along for some time, I pulled my coat around me, slid back off the tree log and lay in the deep leaves, lookin’ up through the tree branches and red leaves to the blue sky where slow clouds drifted peaceably by.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("So on that deep bed of leaves, in the quiet morning, I fell asleep. Shouldn’t have, but I did. Slept deep and dreamed. Dreamed myself right back to where this expedition had all begun, one sunny afternoon three months before. I was pumpin’ the bellows in my brother’s smithy. Little George—my brother—he was at the forge fire, hammer in hand. We was forgin’ chain. Then all of a sudden in walked Master Jefferson. Walked in and came over right close to me, saying not a word, only watchin’ just exactly how I pumped the bellows, what color flame I kept, how much charcoal was left. Every little ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("detail counted with him, and I was terribly afraid there must be some detail I had wrong, only I didn’t know which. Then he went over and watched my brother real close up, same as he done me, and got out his stick rule and measured to the inch how much iron rod we had used, to figure wastage, and wrote in his vest pocket notebook with a stub pencil. I could see the sweat on Little George’s brow, for Master Jefferson he did not like wastage.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he said, in a perfectly usual voice and lookin’ straight at my brother, “Send Isaac up to the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I nearly fell against the bellows. What had I done so very wrong that I must go up to the Big House?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Little George he put his hammer right down. “Yes, suh. Now?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“When you come to a break point,” said Master Jefferson. He stood a moment longer, inspectin’ us both, then turned out the door, blockin’ the sun as he done so, and was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked at my big brother. “I pumped the bellows even as could be, two counts on the downstroke, two counts on the up.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Little George held open his hand to show a length of iron rod no longer than two thumbs end to end. “This is my only wastage and was going to use it as a door bolt.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I flung up my arms. “So why does he want me up at the Big House?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You tell me. I hope to God you ain’t got us both in trouble. Did you get the wood split?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Split and stacked.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Carry up the water?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Twenty buckets.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v(" Little George chewed his lip. “You didn’t get into Mr. Jefferson’s ice cream again, did you?”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You ain’t lying to me, is you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I only took a finger swipe.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How many times I got to tell you, Isaac,” exclaimed my brother, pushin’ at his sleeves and tuggin’ at his apron as he would do when upset, “stay out of Mama’s pastry kitchen. You know Mr. Jefferson don’t want no black finger in his ice cream. It’s bad luck.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Don’t you think I know that by now?” I said, agitated by his tone. “I’m fifteen, or near. Besides, how’s he to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Little George shook his head. “You know as well as I do Old Master seems to know about everything that goes on anywhere on this big ol’ plantation of his.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I couldn’t argue that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Now, pick up your tongs and get a bite on that link.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I done, and Little George he forged the link. “Go on then,” he said and waved a hand. “Go on to Old Master, but don’t dawdle.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I run all the way, hoppin’ over the big rock and swingin’ ’round the sassafras tree just where the path bent, and only when I came to the trim-cut lawn did I slow to a walk and catch my breath. There I stopped a moment to settle my jitters, then stepped around the corner of the Big House. At the east front, under the tall columns, stood Master Jefferson all by himself.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("He was still plain dressed in scuffed boots, worn trousers, and open shirt, not yet suited up for dinner. Even so, he had a bearing about him, whatever clothes he wore. I badly wanted ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("to turn right around and run back to the smithy, but said to myself, “stand firm now and take your medicine.” I drew a deep breath and walked slow across the raked drive and right up under the columns and stood quiet to one side, at a respectful distance. He was hummin’, which eased my mind a good deal, and though he saw me come up, kept on hummin’ a while yet.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he folded his long arms across his chest and looked over at me. “Isaac,” he said, “I have been studying you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, sir,” I said, nervous as could be. “I hope what you have been studyin’ of me pleased you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It has, Isaac. It has. Among all my young servants, you stand out as the one most diligent and capable.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was afraid then he was going to hire me out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Instead, he asked me a most unlikely question. “How would you like to learn a trade?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was caught off guard. “Little George he already teachin’ me to blacksmith.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I mean in a formal sense. As an apprentice, under a Master Craftsman. Would you like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I fairly leaped in the air. “Oh, yes sir,” I said, “I would, I truly would!” Then felt how foolish I must appear to him, standin’ there so tall and grave, and settled myself. “If it please you, Master.” For suddenly I wondered what trade it would be, if not blacksmithin’, and just who the Master Craftsman was to be.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It does please me,” he said, watching me close. “So I have considered what trade. Tinsmithing will do for you, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tinsmithin’?” I asked in surprise. “Anybody ’round here do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He rubbed his hands together. “No, Isaac. Nobody.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v(" “Who would teach me then?”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Old Master smiled and laid his long-fingered hand on my shoulder. “Isaac Granger, son of Great George and Queen Ursula, faithful servants to me, lo these many years, I have arranged for you to be taught by none other than Mr. James Bringhouse.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I felt the weight of Old Master’s hand on me. “Never heard of that man.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s because he lives in Philadelphia.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Philadelphia!” I said, plain shocked. “But that’s nearly another country, ain’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Some would say so,” he said, “with its Quakerism and mercantile obsessions. But I wish you to learn from the best, and James Bringhouse is the best tinsmith in the whole of eastern Pennsylvania.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That sounded to me like a mighty big territory. “He a pretty important man, then,” I said, hardly able to believe that Old Master would choose out such a man, from such a distance, to teach me in particular his solemn trade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“An important man, for an important future,” said Master Jefferson, puttin’ out his hands as if to take hold of that future. “Tin ware, my boy, is no longer just for the military. The country is growing, and the demand for tin with it. There’s money to be made in tin and I want you in it. I "), _c('i', [_vm._v("need")]), _vm._v(" you in it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, Master,” I said. “When this Mr. Bringhouse show at your door, I shall be ready to learn.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Master Jefferson looked at me and smiled. “Oh, he’s too busy to come all the way down here just now, Isaac. I mean for you to work under him at "), _c('i', [_vm._v("his")]), _vm._v(" place of business.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I am sure my mouth must have dropped open. “You don’t mean up there in Philadelphia,” I stuttered out, “do you?”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v(" “I do,” he said, his face almost radiant with that smile of his.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("The prospect scared me. “I could get lost goin’ up there, Master,” I said. “Or nabbed. It’s such a long ways. I never been any such distance all by myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh, I wouldn’t send you out on the road alone, you should know that,” he said reassuringly, as if it was no trouble at all, me leavin’ hearth and family and friends and my set ways. “No, you shall go with me, for I must go to Philadelphia, too. Though in truth I should rather not. The dam needs repair. Our farming methods must reform. And I have designs for my house.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mr. Jefferson he was never done with his house. Always buildin’ it up and tearin’ it down. Why, Polly, his youngest, she fell through a door one time. Didn’t know the steps was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Old Master he sighed. “It shall be no pleasure, being Secretary of State. But such is duty, Isaac. Duty.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The word fell heavily upon me. “Yes sir, duty,” I said. “The very word.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So, it shall give me pleasure,” he said, “while I dutifully grind away at the business of government in the State House, to think of you some blocks away profitably at work learning the useful trade of tinsmithing from Mr. Bringhouse. You shall find no rascals in his domicile. He is Quaker through and through: sober, devout, and keeps his shop as clean as a church pew.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I knew nothin’ about Quakers at that time except two things: they were said to quake and shiver in church, and they was all against slavery. Old Master would send me up there to work with such a man? Now, that was a mystery.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v(" “We shall leave for Philadelphia the first week of September,” he said, looking into the distance. I looked out upon that distance, too, green first, then blue beyond. When the leaves turned, I would be headin’ off into that beautiful distance. Suddenly I had a hankerin’ to go. To leave all behind and strike out new.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“Now you best return to the smithy,” said Master Jefferson. “Lest your brother get behind on the chain work.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, Master. I is off to it, right now.” Then I took off running.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Isaac Granger, Tinsmith!” called out Old Master after me.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("But soon as I got ’round back of the Big House and on the footpath through the woods, I slowed. Questions sprung up in me. Philadelphia, way up north, with me in it, at a trade I knew nothin’ of, under this Mr. Bringhouse? What if I did poorly? What if he was ornery and took a dislike to me? Would there be others learnin’ the trade in his shop, or just me alone? Would there be any other Negroes around, and if so what did they do? There would be no Papa to speak on my behalf, no Mama to settle things with a hot pastry. I stopped at the sassafras tree and hung on the limb. I didn’t want to go, no I didn’t. I had it good right where I was and didn’t want no change. I was a Granger, after all. Not a Hemings, but still. I would beg Mr. Jefferson to send somebody else, I thought. Maybe Aaron. He would go. But namin’ that boy changed my mind, right off. He would leap at the chance, he would, and leave me to feel left behind. That was no good. So my thinkin’ on the matter shifted. I was up to it, sure I was. I was tired of this old mountain, seven miles from anywhere. Let me try my hand at the tinsmithin’ trade up there in Philadelphia. ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("I let go the sassafras tree, hopped the big rock, and ran, full of myself, then slowed once again. Where would I stay all that time up there, I wondered. With Mr. Bringhouse and his family, I guessed. That’s what ’prentices did. But they was white people, had to be. Now how could I live in the same house with white people?")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("So my thoughts went, ‘till I came to the back of Little George’s shop, with old barrel staves propped against the chimney.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Little George was waiting for me when I got inside. “Didn’t I tell you not to dawdle?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I didn’t dawdle,” I said. “Old Master had a lot on his mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll bet he did. Was it about the ice cream? Or something worse? Probably something worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No,” I said, going to the bellows, “nothing of the kind.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Well, what was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Big brother,” I said, and began to pump air into the forge, “I am goin’ to Philadelphia, to be a proper tinsmith up there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I told you, don’t lie to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I ain’t lyin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Does Papa know?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His question fell on me like a weight. “I don’t know. I didn’t think to ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So, he is going to have to suffer the indignity of learning this from you—or somebody else.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I shrugged. “I can’t help that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He’s not going to be happy, you know. Not happy at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I know.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Then Little George got downright mad. “Damn it,” he said, ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“quit pumpin’ that bellows. Fire’s hot enough. Get yourself around here and pick up them tongs.”")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("His tone made "), _c('i', [_vm._v("me")]), _vm._v(" mad. I set my fists against my hips and stuck out my elbows. “I don’t want to pick up no tongs,” I shouted out. “This man, I say "), _c('i', [_vm._v("this")]), _vm._v(" man, he goin’ to Philadelphia!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suddenly, I was most rudely awoken from my dream by James Hemings, who stood over me pokin’ at my chest with the butt end of his horsewhip. “Asleep already are we, Granger?” he said, and poked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I jumped to my feet, or tried to, but slipped on the dry leaves and fell down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("James looked back to the coach and matched pair standing impatient in the road. “No, Master,” he called out, “the Granger boy is not hurt. Just asleep, if you can believe that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I got to my feet this time and brushed the leaves off. Both Mr. Jefferson and Mr. Rattiff were turned in their seats, watchin’ out the window.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("James dropped the horsewhip and got me by the collars with both hands. “You’re an embarrassment to our race, you know that? Now get your poor black ass back in the saddle. And don’t you lag, for God’s sake. Mr. Jefferson keeps a brisk pace.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I got no pass,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You don’t need no pass. Keep up.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But if I should need one.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I said, keep up. We going the Fredericksburg Road, and shall put up tonight at Old Nat Gordon’s place. Simple as that.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“Yes, but suppose I do get behind. You think Mr. Jefferson ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("would like it if paddyrollers nabbed me as a runaway, because you set me on a nag that couldn’t keep up?”")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("James gave me a hateful look. “Damn you,” he said. He let go my collars, got his horsewhip in hand again, stomped back to the coach, and stood there talkin’ to Old Master. Some moments later he came back and slapped a paper in my hand. “You owe me,” he said, then stomped back to the coach again. He took his seat, snapped the whip, and away the whole party went at a good trot, with much creaking of the axletree and pounding of hooves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have that paper still. It was torn from the little book Mr. Jefferson always kept in a pocket and written out on it were these words in pencil: "), _c('i', [_vm._v("This man Isaac Granger is the property of Thomas Jefferson, who hereby gives permission that said Negro should travel the Fredericksburg Road without hamperment")]), _vm._v(", and signed by him. But I wasn’t no man then, oh no I wasn’t.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba3a34e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter05.vue
// module id = 90
// module chunks = 0